import React from 'react';
import { useLanguage } from '../../../hooks/useLanguage.js';
import { formatDateWithLanguage } from '../../../utils/get-date';
import { translate } from '../../../utils/wp.js';
import { Dropdown } from '../../Dropdown';

function getDaySpan(from, to, language) {
    return [
        formatDateWithLanguage(from, 'E', language),
        formatDateWithLanguage(to, 'E', language),
    ].join(' - ');
}

export function RangesSelector({days, value, disabled, onChange}) {
    const [language] = useLanguage();

    return (
        <Dropdown
            label={`${translate('stay')}: ${getDaySpan(
                days[value].from,
                days[value].to,
                language,
            )}`}
            value={value}
            options={days.map((day, i) => ({
                value: i,
                label: getDaySpan(day.from, day.to, language),
            }))}
            disabled={disabled}
            onChange={onChange}
        />
    );
}
